import { useWriteErrorStore } from "@api/writeErrorStore";
import { MessageSlip } from "@scribenote/brian-design-system";

/**
 * Mutations without their own error UI land here via the `MutationCache`; never auto-dismissed.
 * `key={seq}` remounts so `role="alert"` fires again even for identical text.
 */
export const WriteErrorNotice = () => {
  const message = useWriteErrorStore((s) => s.message);
  const seq = useWriteErrorStore((s) => s.seq);
  const dismiss = useWriteErrorStore((s) => s.dismiss);

  if (!message) return null;

  return (
    <MessageSlip
      key={seq}
      message={message}
      onDismiss={dismiss}
      data-testid="write-error-notice"
    />
  );
};
